export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A1628] rounded-t-3xl relative overflow-hidden">
      <div className="absolute bottom-0 right-0 text-[#1a2e47] text-[180px] font-bold opacity-5 select-none">
        VIAPREC
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/62cb6fed-9197-40aa-b467-cf5dbb51758b.png"
                alt="VIAPREC Logo"
                className="h-10 w-auto"
              />
              <span className="text-2xl font-bold text-white">VIAPREC</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Your Privacy, Our Priority
            </p>
          </div>

          <div>
            <h3 className="text-white text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-[#00D4FF] transition-colors duration-300 cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('vpn-services')}
                  className="text-gray-400 hover:text-[#00D4FF] transition-colors duration-300 cursor-pointer"
                >
                  VPN Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-[#00D4FF] transition-colors duration-300 cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-gray-400 hover:text-[#00D4FF] transition-colors duration-300 cursor-pointer"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-[#00D4FF] transition-colors duration-300 cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-lg font-bold mb-4">Legal</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00D4FF] transition-colors duration-300 cursor-pointer">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00D4FF] transition-colors duration-300 cursor-pointer">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00D4FF] transition-colors duration-300 cursor-pointer">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-lg font-bold mb-4">Stay Updated</h3>
            <p className="text-gray-400 mb-4 text-sm">
              Subscribe to our newsletter for security tips and updates.
            </p>
            <div className="relative">
              <input
                type="email"
                placeholder="Your email"
                className="w-full px-4 py-3 bg-[#1A2332] text-white rounded-full focus:outline-none focus:ring-2 focus:ring-[#00D4FF] pr-12 text-sm"
              />
              <button className="absolute right-1 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-[#00D4FF] transition-colors duration-300 cursor-pointer">
                <i className="ri-arrow-right-line text-[#0A1628]"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="border-t-2 border-[#00D4FF]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © 2025 VIAPREC S.R.L. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-[#00D4FF] transition-colors duration-300 text-sm cursor-pointer"
              >
                Powered by Readdy
              </a>
              <div className="flex items-center space-x-4">
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center border-2 border-gray-600 rounded-full hover:border-[#00D4FF] hover:bg-[#00D4FF] transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-gray-400 hover:text-white"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center border-2 border-gray-600 rounded-full hover:border-[#00D4FF] hover:bg-[#00D4FF] transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-twitter-x-fill text-gray-400 hover:text-white"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center border-2 border-gray-600 rounded-full hover:border-[#00D4FF] hover:bg-[#00D4FF] transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-facebook-fill text-gray-400 hover:text-white"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
